import React, { useEffect, useState } from "react";

function BalanceSheetGroup(props) {

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
        ? JSON.parse(localStorage.getItem("apiPaths"))
        : "-";

    const { datagetTrialBalanceReport, parentDetails, selected_mode_table_structure } = props;
    const [expandedNodes, setExpandedNodes] = useState({});

    useEffect(() => {
        if (datagetTrialBalanceReport) {
            const allExpanded = Object.fromEntries(
                datagetTrialBalanceReport.map((d) => [d.NODE, true])
            );
            setExpandedNodes(allExpanded);
        }
    }, [datagetTrialBalanceReport]);

    return (
        <div className="min-h-screen bg-gray-200 py-10 px-4">
            <div className="max-w-4xl mx-auto bg-white shadow-xl rounded-none border border-gray-300  px-4 pt-4 pb-6 overflow-x-auto">

                <div>

                    <div>


                        {apiPaths_from_local_storage[0]?.REP_HEADER?.includes("data:image/") && (
                            <img
                                src={apiPaths_from_local_storage[0].REP_HEADER}
                            />
                        )}

                    </div>

                    <div style={{
                        fontSize: '18px',
                        fontWeight: '500',
                        color: '#0f172a',
                        textAlign: 'center',
                        textTransform: 'uppercase',
                        margin: '20px 0',
                        padding: '10px 16px',
                        backgroundColor: '#f8fafc',
                        borderRadius: '6px'
                    }}>
                        {
                            selected_mode_table_structure.find(
                                (item) => item.mode_table_code === parentDetails.mode_list_array.find((m) => m.is_selected)?.mode_code
                            )?.mode_table_name
                        }
                    </div>

                </div>

                <table className="min-w-full divide-y divide-gray-200 text-sm mt-3">
                    <thead className="border-b-2 border-gray-900">
                        <tr>
                            {selected_mode_table_structure
                                .find((item) => item.mode_table_name === parentDetails.mode_list_array.find((m) => m.is_selected)?.mode_name)
                                ?.mode_table_columns.filter((col) => col.column_key_from_api !== "NODE" && col.column_key_from_api !== "BALANCE")
                                .map((item, i) => (
                                    <th
                                        key={i}
                                        className={`px-4 py-2 text-xs font-bold text-gray-900 uppercase tracking-wider ${["DEBIT", "CREDIT"].includes(item.column_key_from_api) ? "text-right" : "text-left"
                                            }`}
                                    >
                                        {item.column_name}
                                    </th>
                                ))}
                        </tr>
                    </thead>

                    <tbody className="divide-y divide-gray-100">
                        {(() => {
                            // Filter visible columns (exclude NODE and BALANCE)
                            const visibleColumns = selected_mode_table_structure
                                .find((item) => item.mode_table_name === parentDetails.mode_list_array.find((m) => m.is_selected)?.mode_name)
                                ?.mode_table_columns.filter((col) => col.column_key_from_api !== "NODE" && col.column_key_from_api !== "BALANCE") || [];

                            // colSpan for subtotal / grandtotal labels = everything before DEBIT column
                            const debitIndex = visibleColumns.findIndex((col) => col.column_key_from_api === "DEBIT");
                            const labelColSpan = debitIndex > 0 ? debitIndex : 1;

                            // Calculate Net Grand Totals
                            const grandTotal = datagetTrialBalanceReport.reduce(
                                (acc, r) => {
                                    const bal = r.BALANCE || 0;
                                    if (bal > 0) {
                                        acc.DEBIT += bal;
                                    } else if (bal < 0) {
                                        acc.CREDIT += Math.abs(bal);
                                    }
                                    return acc;
                                },
                                { DEBIT: 0, CREDIT: 0 }
                            );

                            return (
                                <>
                                    {Object.entries(
                                        datagetTrialBalanceReport.reduce((acc, row) => {
                                            if (!acc[row.NODE]) acc[row.NODE] = [];
                                            acc[row.NODE].push(row);
                                            return acc;
                                        }, {})
                                    ).map(([node, rows], nodeIndex) => {

                                        // Calculate Net Node Subtotals
                                        const nodeSubtotal = rows.reduce(
                                            (acc, r) => {
                                                const bal = r.BALANCE || 0;
                                                if (bal > 0) {
                                                    acc.DEBIT += bal;
                                                } else if (bal < 0) {
                                                    acc.CREDIT += Math.abs(bal);
                                                }
                                                return acc;
                                            },
                                            { DEBIT: 0, CREDIT: 0 }
                                        );

                                        return (
                                            <React.Fragment key={nodeIndex}>
                                                {/* NODE HEADER */}
                                                <tr
                                                    className="border-t border-gray-200 cursor-pointer hover:bg-gray-50"
                                                    onClick={() =>
                                                        setExpandedNodes((prev) => ({ ...prev, [node]: !prev[node] }))
                                                    }
                                                >
                                                    <td
                                                        colSpan={visibleColumns.length}
                                                        className="px-4 py-2 font-bold text-gray-900 text-sm flex items-center gap-2 uppercase tracking-wide"
                                                    >
                                                        <span className={`transition-transform ${expandedNodes[node] ? "rotate-90" : ""}`}>
                                                            ▶
                                                        </span>
                                                        {node}
                                                    </td>
                                                </tr>

                                                {/* ROWS UNDER NODE */}
                                                {expandedNodes[node] &&
                                                    rows.map((row, i) => (
                                                        <tr key={i} className="hover:bg-gray-50">
                                                            {visibleColumns.map((col, ci) => {
                                                                const key = col.column_key_from_api;
                                                                const balance = row["BALANCE"] || 0;
                                                                let displayValue = row[key];

                                                                // Logic to calculate Balance for Debit/Credit display
                                                                if (key === "DEBIT") {
                                                                    displayValue = balance > 0 ? balance.toFixed(2) : "";
                                                                } else if (key === "CREDIT") {
                                                                    displayValue = balance < 0 ? Math.abs(balance).toFixed(2) : "";
                                                                }

                                                                return (
                                                                    <td
                                                                        key={ci}
                                                                        className={`px-4 py-2 text-sm ${["DEBIT", "CREDIT"].includes(key)
                                                                                ? "text-right tabular-nums font-mono"
                                                                                : "text-left text-gray-700"
                                                                            } ${key === "DEBIT"
                                                                                ? "text-blue-700"
                                                                                : key === "CREDIT"
                                                                                    ? "text-emerald-700"
                                                                                    : ""
                                                                            }`}
                                                                    >
                                                                        {displayValue}
                                                                    </td>
                                                                );
                                                            })}
                                                        </tr>
                                                    ))}

                                                {/* NODE SUBTOTAL */}
                                                {expandedNodes[node] && (
                                                    <tr className="border-t border-dashed border-gray-300 font-medium text-sm">
                                                        <td colSpan={labelColSpan} className="px-4 py-1.5 italic text-gray-500 text-xs">
                                                            Subtotal — {node}
                                                        </td>
                                                        <td className="px-4 py-1.5 text-right tabular-nums font-mono text-blue-700 text-xs">
                                                            {nodeSubtotal.DEBIT > 0 ? nodeSubtotal.DEBIT.toFixed(2) : ""}
                                                        </td>
                                                        <td className="px-4 py-1.5 text-right tabular-nums font-mono text-emerald-700 text-xs">
                                                            {nodeSubtotal.CREDIT > 0 ? nodeSubtotal.CREDIT.toFixed(2) : ""}
                                                        </td>
                                                    </tr>
                                                )}
                                            </React.Fragment>
                                        );
                                    })}

                                    {/* GRAND TOTAL */}
                                    <tr className="font-bold text-sm" style={{ borderTop: "3px double #111827" }}>
                                        <td colSpan={labelColSpan} className="px-4 py-3 text-gray-900 uppercase tracking-wide text-xs">
                                            Grand Total
                                        </td>
                                        <td className="px-4 py-3 text-right tabular-nums font-mono text-blue-800">
                                            {grandTotal.DEBIT > 0 ? grandTotal.DEBIT.toFixed(2) : ""}
                                        </td>
                                        <td className="px-4 py-3 text-right tabular-nums font-mono text-emerald-800">
                                            {grandTotal.CREDIT > 0 ? grandTotal.CREDIT.toFixed(2) : ""}
                                        </td>
                                    </tr>

                                    {/* DIFFERENCE ROW (IF UNBALANCED) */}
                                    {grandTotal.DEBIT !== grandTotal.CREDIT && (
                                        <tr className="bg-red-100 font-semibold border-t border-red-300">
                                            <td colSpan={labelColSpan} className="px-4 py-2 text-red-800 uppercase tracking-wide text-xs">
                                                Difference
                                            </td>
                                            <td colSpan="2" className="px-4 py-2 text-right tabular-nums font-mono text-red-700">
                                                {Math.abs(grandTotal.DEBIT - grandTotal.CREDIT).toFixed(2)}
                                            </td>
                                        </tr>
                                    )}
                                </>
                            );
                        })()}
                    </tbody>
                </table>

                {/* Report Footer */}
                <div className="mt-8">
                    <div className="border-t-2 border-gray-900" />
                    <div className="mt-0.5 border-t border-gray-300" />
                    <div className="mt-4 flex justify-between items-center">
                        <p className="text-xs text-gray-400">
                            Generated: {new Date().toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })}
                        </p>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default BalanceSheetGroup;